import React, { useState } from 'react';
import { FadeIn } from './Shared';
import { Plus, Minus } from 'lucide-react';
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-navy-700" data-id="element-73">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-74">
        <span className="text-lg font-medium text-white pr-8" data-id="element-75">{question}</span>
        {isOpen ? <Minus className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-76" /> : <Plus className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-77" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-78">
        <p className="text-gray-400 leading-relaxed" data-id="element-79">{answer}</p>
      </div>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Funciona para cualquier edad?',
    a: 'Sí, el sistema está diseñado específicamente para bebés de 0 a 36 meses. El Tomo 3 incluye las ventanas de sueño dinámicas exactas para cada etapa de desarrollo, ya que las necesidades cambian mes a mes.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un correo electrónico en menos de 5 minutos con el enlace para descargar todos los tomos y bonos en formato PDF, listos para leer en tu celular, tablet o computadora.'
  }, {
    q: '¿Es un método de llanto controlado?',
    a: 'No. El Tomo 4 (Autonomía Gradual) se enfoca en enseñar a dormir de forma respetuosa, acompañando al bebé y reduciendo la intervención poco a poco. No creemos en dejar llorar al bebé solo en la habitación.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Totalmente. Tenés 7 días para leer el material y aplicarlo. Si sentís que no te aporta valor o no ves mejoras, nos enviás un correo y te devolvemos el 100% de tu dinero, sin hacer preguntas.'
  }];
  return <section className="py-8 md:py-12 px-4 bg-navy-800/30" data-id="element-80">
      <div className="max-w-3xl mx-auto" data-id="element-81">
        <FadeIn data-id="element-82">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-white mb-8" data-id="element-83">
            ❓ PREGUNTAS FRECUENTES
          </h2>
          <div className="bg-navy-900 rounded-2xl border border-navy-700 p-6 md:p-8" data-id="element-84">
            {faqs.map((faq, index) => <AccordionItem key={index} question={faq.q} answer={faq.a} data-id="element-85" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
};